import { get } from 'lodash';

export const getVendingMachinesLoading = state =>
  get(state, 'VendingState.getVendingMachines.loading');
export const getVendingMachinesResult = state =>
  get(state, 'VendingState.getVendingMachines.data');

export const postVendingMachineLoading = state =>
  get(state, 'VendingState.postVendingMachine.loading');
export const postVendingMachineResult = state =>
  get(state, 'VendingState.postVendingMachine.data');
export const postVendingMachineErrors = state =>
  get(state, 'VendingState.postVendingMachine.errors');

export const postDeleteVendingMachineLoading = state =>
  get(state, 'VendingState.postDeleteVendingMachine.loading');
export const postDeleteVendingMachineResult = state =>
  get(state, 'VendingState.postDeleteVendingMachine.data');
export const postDeleteVendingMachineErrors = state =>
  get(state, 'VendingState.postDeleteVendingMachine.errors');



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/state/selectors.js